export const normalizeSlug = (slug) => {
  if (typeof slug !== 'string') {
    return '/';
  }

  return `/${slug}`.replace(/\/+/, '/').replace(/^(\/.+[^\/])\/*$/g, '$1');
};
